module.exports = __webpack_public_path__ + "static/media/date_24px_533395_easyicon.net.3d84369e.ico";